import React, { useEffect, useState } from 'react';
import { IProps, IState } from './types';
import * as S from './styles';

const CARD_WIDTH = 570;
const CARD_HEIGHT = 380;
const RATIO = 1.5;

const Preview:React.FC<IProps> = (props) => {
  const previews = props.files[props.currentIndex]?.previews;
  const [images, setImages] = useState<IState['images']>([]);

  useEffect(() => {
    if (previews?.length > 0) {
      var newImages: any = [];
      var maxWidthIndex = 0;
      var maxWidthValue = 0;
      previews.map((image: any, index: number) => {
        var name = image?.name?.toString().split('x');
        var newImage = {...image};
        if (name && name.length > 1 && parseInt(name[0]) && parseInt(name[1])) {
          if (name[0]/RATIO > CARD_WIDTH) newImage.width = CARD_WIDTH
          else newImage.width = name[0]/RATIO;
          if (name[1]/RATIO > CARD_WIDTH) newImage.height = CARD_HEIGHT
          else name.height = name[1]/RATIO;
        } else {
          newImage.width = CARD_WIDTH;
          newImage.height = CARD_HEIGHT;
        }
        if (name && name[0] > maxWidthValue) {
          maxWidthValue = name[0];
          maxWidthIndex = index;
        }
        newImages = [...newImages, newImage];
      });
      newImages = [
        newImages[maxWidthIndex],
        ...newImages.slice(0, maxWidthIndex),
        ...newImages.slice(maxWidthIndex + 1)
      ]
      setImages(newImages);
    }
  }, [previews])

  return (
    <S.Root >
      <S.RenderBox
        id="preview-template-container"
        style={{
          display: previews?.length > 0 ? 'block' : 'none',
        }}
      >
        <S.Grid>
        { images?.length > 0 &&
          images.map((image: any, index: number) => {
            return (
              <S.GridItemContainer key={index} >
                { image.name !== '' &&
                  <S.GridTitle>
                    {image.name}
                  </S.GridTitle>
                }
                <S.GridItem
                  src={image.url}
                  width={image.width}
                  height={image.height}
                />
              </S.GridItemContainer>
            )
          })
        }
      </S.Grid>
      </S.RenderBox>
      <S.EmptyTitle style={{
        display: previews?.length > 0 ? 'none' : 'block',
      }}>
        Upload file to see preview here
      </S.EmptyTitle>
    </S.Root >
  );
}

export default Preview;